export const TRANSLATIONS = {
  fr: {
    nav: [
      { label: "Accueil", href: "#accueil" },
      { label: "À propos", href: "#apropos" },
      { label: "Services", href: "#services" },
      { label: "Secteurs", href: "#secteurs" },
      { label: "Équipe", href: "#equipe" },
      { label: "Partenaires", href: "#partenaires" },
      { label: "Suivi", href: "#suivi" },
      { label: "Contact", href: "#contact" },
    ],
    cta: "Demander un devis",
    hero: {
      tagline: "Agence en Douane",
      title1: "L'excellence logistique",
      title2: "douanière",
      desc: "Depuis 2019, GLS — agence en douane et commissionnaire en douane en RDC — accompagne les entreprises des secteurs minier, automobile, pharmaceutique et commercial : dédouanement, transit, logistique, transport de colis et import-export, de Lubumbashi à Kinshasa et partout en RDC.",
      ctaServices: "Découvrir nos services",
      stats: [
        { value: "2019", label: "Année de création" },
        { value: "4+", label: "Secteurs d'expertise" },
        { value: "20+", label: "Partenaires de confiance" },
        { value: "100%", label: "Conformité douanière" },
      ],
    },
    about: {
      kicker: "À propos de nous",
      title: "Votre partenaire de confiance en transit et dédouanement",
      p1: "Fondée en 2019, Groupe Lupatash Service SARL (GLS) est une agence en douane et commissionnaire en douane agréé en RDC, spécialisée dans les secteurs minier et automobile. Basée à Lubumbashi avec une agence à Kinshasa, elle intervient également dans les domaines pharmaceutique et commercial pour toutes vos opérations d'import et export en RDC.",
      p2: "Notre équipe de professionnels assure le scan, l'inspection et l'acheminement de vos marchandises jusqu'au lieu de livraison, avec rigueur et conformité réglementaire.",
      points: [
        "Agréée comme agence en douane",
        "Équipe de professionnels certifiés",
        "Couverture multi-sectorielle",
        "Suivi et traçabilité en temps réel",
      ],
      foundedLabel: "Année de fondation de GLS",
      features: ["Conformité totale", "Délais maîtrisés", "Réseau international"],
    },
    services: {
      kicker: "Nos services",
      title: "Des solutions complètes, du port à la livraison",
      desc: "Nous prenons en charge l'intégralité de votre chaîne logistique et douanière, avec une expertise pointue à chaque étape.",
      items: [
        { icon: "ClipboardCheck", title: "Dédouanement", desc: "Procédures douanières complètes : déclarations import/export, classement tarifaire, et gestion des régimes douaniers en toute conformité." },
        { icon: "Ship", title: "Import & Export", desc: "Coordination de bout en bout de vos flux internationaux, du port d'origine jusqu'à la livraison finale, par voie maritime et terrestre." },
        { icon: "Truck", title: "Transport & Logistique", desc: "Acheminement sécurisé de vos marchandises et transport de colis partout en RDC, avec une flotte adaptée aux secteurs miniers, automobiles et industriels." },
        { icon: "FileCheck2", title: "Transit & Conseil", desc: "Accompagnement réglementaire, gestion documentaire et optimisation des coûts de transit pour vos opérations transfrontalières." },
        { icon: "ScanLine", title: "Inspection & Scanning", desc: "Contrôle, scan et vérification des cargaisons par notre équipe de professionnels agréés pour une traçabilité totale." },
        { icon: "Warehouse", title: "Entreposage", desc: "Solutions d'entreposage sous douane et stockage temporaire sécurisé pour vos marchandises en attente de dédouanement." },
      ],
      bannerTitle: "Transport sécurisé, partout.",
      bannerDesc: "Une flotte adaptée pour acheminer vos marchandises d'un point à l'autre, en toute fiabilité.",
    },
    sectors: {
      kicker: "Nos secteurs",
      title: "Une expertise au cœur de votre industrie",
      desc: "GLS maîtrise les exigences spécifiques de chaque secteur pour offrir un service sur mesure.",
      items: [
        { icon: "Pickaxe", title: "Mines", desc: "Expertise reconnue dans l'import/export d'équipements et de produits miniers, avec une maîtrise des contraintes logistiques lourdes." },
        { icon: "Car", title: "Automobile", desc: "Transit et dédouanement de véhicules et de pièces détachées, avec une logistique dédiée au transport automobile." },
        { icon: "Pill", title: "Pharmaceutique", desc: "Gestion rigoureuse des produits sensibles, dans le respect des normes sanitaires et des chaînes de conservation." },
        { icon: "ShoppingCart", title: "Commercial", desc: "Solutions complètes pour les marchandises commerciales, de l'approvisionnement à la distribution sur le marché local." },
      ],
    },
    team: {
      kicker: "Notre Équipe",
      title: "Une direction engagée à votre service",
      members: [
        {
          name: "Mme Lukenge Pataoli Asha Konde",
          role: "Directrice Générale",
          desc: "À la tête du Groupe Lupatash Service depuis sa création, elle pilote la vision stratégique de l'agence et veille à l'excellence de chaque opération douanière.",
        },
      ],
    },
    partners: {
      kicker: "Ils nous font confiance",
      title: "Des partenaires de référence",
      desc: "GLS a accompagné de grandes entreprises telles que AECL, SicoMine, Jambo Mart, Malibu Cars et bien d'autres.",
    },
    testimonials: {
      kicker: "Témoignages",
      title: "La confiance de nos partenaires",
      items: [
        { company: "SicoMine", author: "Direction Logistique", icon: "Pickaxe", quote: "GLS gère le dédouanement de nos équipements miniers avec une rigueur exemplaire. Les délais sont respectés et la conformité est totale, même sur les cargaisons les plus complexes." },
        { company: "Malibu Cars", author: "Service Import", icon: "Car", quote: "Pour l'importation de nos véhicules, GLS est un partenaire de confiance depuis des années. Transit rapide, documentation impeccable et un suivi permanent de chaque dossier." },
        { company: "Jambo Mart", author: "Responsable Approvisionnement", icon: "ShoppingCart", quote: "Leur équipe connaît parfaitement les procédures douanières congolaises. Nos marchandises commerciales arrivent en rayon sans retard, une vraie tranquillité d'esprit." },
        { company: "AECL", author: "Direction des Opérations", icon: "Building2", quote: "Un professionnalisme rare dans le secteur. GLS anticipe les contraintes réglementaires et nous propose toujours la solution de transit la plus efficace." },
      ],
    },
    tracking: {
      kicker: "Suivi de dossier",
      title: "Suivez votre dédouanement en temps réel",
      desc: "Entrez la référence de votre dossier (fournie par notre équipe, ex. GLS-2026-A1B2C3D4) pour consulter l'avancement de vos opérations douanières.",
      placeholder: "Référence du dossier — ex. GLS-2026-A1B2C3D4",
      button: "Suivre",
      notFound: "Aucun dossier trouvé avec cette référence",
      tooMany: "Trop de requêtes. Veuillez réessayer plus tard.",
      refLabel: "Référence",
      historyLabel: "Historique",
      statuses: [
        { code: "recu", label: "Dossier reçu" },
        { code: "documents", label: "Vérification des documents" },
        { code: "declaration", label: "Déclaration en douane" },
        { code: "liquidation", label: "Liquidation & paiement" },
        { code: "libere", label: "Marchandise libérée" },
        { code: "livre", label: "Livré" },
      ],
    },
    contact: {
      kicker: "Contact",
      title: "Demandez votre devis dès aujourd'hui",
      desc: "Une question, un projet de transport ou de dédouanement ? Notre équipe vous répond dans les plus brefs délais.",
      phone: "Téléphone",
      email: "Email",
      agencyLbb: "Agence Lubumbashi",
      agencyKin: "Agence Kinshasa",
      agency: "Agence",
      formName: "Nom complet *",
      formEmail: "Email *",
      formPhone: "Téléphone",
      formCompany: "Entreprise",
      formSubject: "Sujet",
      formMessage: "Message *",
      formPlaceholder: "Décrivez votre besoin...",
      formSend: "Envoyer le message",
      formSending: "Envoi...",
      successTitle: "Merci !",
      successDesc: "Votre message a bien été reçu. Nous vous recontacterons très vite.",
      successAgain: "Envoyer un autre message",
      toastOk: "Message envoyé ! Nous vous recontacterons rapidement.",
      toastErr: "Une erreur est survenue. Veuillez réessayer.",
    },
    footer: {
      tagline: "Agence en douane et commissionnaire en douane en RDC : dédouanement, transit, logistique, import-export et transport de colis à Lubumbashi et Kinshasa depuis 2019.",
      navigation: "Navigation",
      services: "Services",
      contact: "Contact",
      rights: "Tous droits réservés.",
      admin: "Espace administrateur",
    },
    whatsapp: {
      tooltip: "Discutons sur WhatsApp",
      message: "Bonjour GLS, je souhaite obtenir des informations sur vos services de dédouanement.",
    },
    chat: {
      title: "Assistant GLS",
      subtitle: "Propulsé par l'IA — réponses instantanées",
      welcome: "Bonjour ! 👋 Je suis l'assistant virtuel de GLS. Posez-moi vos questions sur nos services de dédouanement, transport, suivi de dossier ou nos agences.",
      placeholder: "Votre question...",
      error: "Désolé, une erreur est survenue. Veuillez réessayer ou nous contacter au +243 975 007 535.",
    },
  },
  en: {
    nav: [
      { label: "Home", href: "#accueil" },
      { label: "About", href: "#apropos" },
      { label: "Services", href: "#services" },
      { label: "Sectors", href: "#secteurs" },
      { label: "Team", href: "#equipe" },
      { label: "Partners", href: "#partenaires" },
      { label: "Tracking", href: "#suivi" },
      { label: "Contact", href: "#contact" },
    ],
    cta: "Request a quote",
    hero: {
      tagline: "Customs Agency",
      title1: "Logistics",
      title2: "customs excellence",
      desc: "Since 2019, GLS — a licensed customs agency and customs broker in the DRC — has supported companies in the mining, automotive, pharmaceutical and commercial sectors: customs clearance, transit, logistics, parcel transport and import-export, from Lubumbashi to Kinshasa and across the DRC.",
      ctaServices: "Discover our services",
      stats: [
        { value: "2019", label: "Year founded" },
        { value: "4+", label: "Sectors of expertise" },
        { value: "20+", label: "Trusted partners" },
        { value: "100%", label: "Customs compliance" },
      ],
    },
    about: {
      kicker: "About us",
      title: "Your trusted partner for transit and customs clearance",
      p1: "Founded in 2019, Groupe Lupatash Service SARL (GLS) is a customs agency specialized in the mining and automotive sectors. Building on its experience, it also operates in the pharmaceutical and commercial fields.",
      p2: "Our team of professionals handles the scanning, inspection and delivery of your goods all the way to their destination, with rigor and full regulatory compliance.",
      points: [
        "Licensed customs agency",
        "Team of certified professionals",
        "Multi-sector coverage",
        "Real-time tracking and traceability",
      ],
      foundedLabel: "Year GLS was founded",
      features: ["Full compliance", "Deadlines under control", "International network"],
    },
    services: {
      kicker: "Our services",
      title: "Complete solutions, from port to delivery",
      desc: "We handle your entire logistics and customs chain, with sharp expertise at every step.",
      items: [
        { icon: "ClipboardCheck", title: "Customs Clearance", desc: "Complete customs procedures: import/export declarations, tariff classification, and customs regime management in full compliance." },
        { icon: "Ship", title: "Import & Export", desc: "End-to-end coordination of your international flows, from the port of origin to final delivery, by sea and land." },
        { icon: "Truck", title: "Transport & Logistics", desc: "Secure transport of your goods with a fleet adapted to the mining, automotive and industrial sectors." },
        { icon: "FileCheck2", title: "Transit & Advisory", desc: "Regulatory support, document management and transit cost optimization for your cross-border operations." },
        { icon: "ScanLine", title: "Inspection & Scanning", desc: "Control, scanning and verification of cargo by our team of licensed professionals for full traceability." },
        { icon: "Warehouse", title: "Warehousing", desc: "Bonded warehousing solutions and secure temporary storage for your goods awaiting customs clearance." },
      ],
      bannerTitle: "Secure transport, everywhere.",
      bannerDesc: "A fleet built to move your goods from one point to another, with complete reliability.",
    },
    sectors: {
      kicker: "Our sectors",
      title: "Expertise at the heart of your industry",
      desc: "GLS masters the specific requirements of each sector to deliver a tailor-made service.",
      items: [
        { icon: "Pickaxe", title: "Mining", desc: "Recognized expertise in the import/export of mining equipment and products, with mastery of heavy logistics constraints." },
        { icon: "Car", title: "Automotive", desc: "Transit and customs clearance of vehicles and spare parts, with logistics dedicated to automotive transport." },
        { icon: "Pill", title: "Pharmaceutical", desc: "Rigorous management of sensitive products, in compliance with health standards and cold chains." },
        { icon: "ShoppingCart", title: "Commercial", desc: "Complete solutions for commercial goods, from sourcing to distribution on the local market." },
      ],
    },
    team: {
      kicker: "Our Team",
      title: "A committed leadership at your service",
      members: [
        {
          name: "Mrs. Lukenge Pataoli Asha Konde",
          role: "Chief Executive Officer",
          desc: "At the helm of Groupe Lupatash Service since its creation, she drives the agency's strategic vision and ensures the excellence of every customs operation.",
        },
      ],
    },
    partners: {
      kicker: "They trust us",
      title: "Leading partners",
      desc: "GLS has supported major companies such as AECL, SicoMine, Jambo Mart, Malibu Cars and many more.",
    },
    testimonials: {
      kicker: "Testimonials",
      title: "The trust of our partners",
      items: [
        { company: "SicoMine", author: "Logistics Department", icon: "Pickaxe", quote: "GLS handles the customs clearance of our mining equipment with exemplary rigor. Deadlines are met and compliance is total, even on the most complex shipments." },
        { company: "Malibu Cars", author: "Import Department", icon: "Car", quote: "For importing our vehicles, GLS has been a trusted partner for years. Fast transit, impeccable documentation and constant follow-up on every file." },
        { company: "Jambo Mart", author: "Procurement Manager", icon: "ShoppingCart", quote: "Their team knows Congolese customs procedures inside out. Our commercial goods reach the shelves without delay — true peace of mind." },
        { company: "AECL", author: "Operations Department", icon: "Building2", quote: "A rare level of professionalism in the industry. GLS anticipates regulatory constraints and always offers us the most efficient transit solution." },
      ],
    },
    tracking: {
      kicker: "File tracking",
      title: "Track your customs clearance in real time",
      desc: "Enter your file reference (provided by our team, e.g. GLS-2026-A1B2C3D4) to check the progress of your customs operations.",
      placeholder: "File reference — e.g. GLS-2026-A1B2C3D4",
      button: "Track",
      notFound: "No file found with this reference",
      tooMany: "Too many requests. Please try again later.",
      refLabel: "Reference",
      historyLabel: "History",
      statuses: [
        { code: "recu", label: "File received" },
        { code: "documents", label: "Document verification" },
        { code: "declaration", label: "Customs declaration" },
        { code: "liquidation", label: "Assessment & payment" },
        { code: "libere", label: "Goods released" },
        { code: "livre", label: "Delivered" },
      ],
    },
    contact: {
      kicker: "Contact",
      title: "Request your quote today",
      desc: "A question, a transport or customs clearance project? Our team will get back to you as soon as possible.",
      phone: "Phone",
      email: "Email",
      agencyLbb: "Lubumbashi Office",
      agencyKin: "Kinshasa Office",
      agency: "Office",
      formName: "Full name *",
      formEmail: "Email *",
      formPhone: "Phone",
      formCompany: "Company",
      formSubject: "Subject",
      formMessage: "Message *",
      formPlaceholder: "Describe your needs...",
      formSend: "Send message",
      formSending: "Sending...",
      successTitle: "Thank you!",
      successDesc: "Your message has been received. We will get back to you very soon.",
      successAgain: "Send another message",
      toastOk: "Message sent! We will get back to you shortly.",
      toastErr: "An error occurred. Please try again.",
    },
    footer: {
      tagline: "Customs agency and licensed customs broker in the DRC: customs clearance, transit, logistics, import-export and parcel transport in Lubumbashi and Kinshasa since 2019.",
      navigation: "Navigation",
      services: "Services",
      contact: "Contact",
      rights: "All rights reserved.",
      admin: "Admin area",
    },
    whatsapp: {
      tooltip: "Chat with us on WhatsApp",
      message: "Hello GLS, I would like information about your customs clearance services.",
    },
    chat: {
      title: "GLS Assistant",
      subtitle: "AI-powered — instant answers",
      welcome: "Hello! 👋 I'm the GLS virtual assistant. Ask me anything about our customs clearance services, transport, file tracking or our offices.",
      placeholder: "Your question...",
      error: "Sorry, an error occurred. Please try again or contact us at +243 975 007 535.",
    },
  },
};
